import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import imgKkp from '../../../assets/images/logo_kkp.jpg'
import srcArial from '../../../assets/custom/font/arial/arial.ttf'
import srcArialBold from '../../../assets/custom/font/arial/ARIBL0.ttf'
import { useCallback, useEffect, useMemo, useState } from "react";
import KapalService from "../../../services/kapal/KapalService";
import { formatDateStringLocalDateINA } from "../../../utilities/Utils";
import JenisDokumenKapal from "../../../utilities/kapal/JenisDokumenKapal";
import imgCheck from "../../../assets/images/icons/check.png"

Font.register({ family: 'Arial', src: srcArial })
Font.register({ family: 'Arial-Bold', src: srcArialBold })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 42,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 115,
        height: 100,
    },
    headingTtd: {
        width: 250,
        height: 123,
    },
    table: {
        display: "table",
        width: "auto"
    },
    tableRow: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    tableCol: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 1
    },
    text: {
        fontSize: 10,
        fontFamily: "Arial"
    },
    textBold: {
        fontSize: 12,
        fontFamily: "Arial-Bold"
    },
    checkicon: {
        width: 12,
        height: 12
    }
})

const CetakFormPeriksaDokPPM = ({ dataDisposisi, dataPpmKapal }) => {

    let kapalService = useMemo(() => new KapalService(), [])

    const [listDokWajib, setListDokWajib] = useState([])
    const [hasilEvpDok, setHasilEvpDok] = useState([])
    const [valueCatatan, setValueCatatan] = useState(null)
    const [valuePemeriksa, setValuePemeriksa] = useState(null)
    const [valueTanggalPeriksa, setValueTanggalPeriksa] = useState(null)
    const [masterKapal, setMasterKapal] = useState(null)
    const [isPembeku, setIsPembeku] = useState(null)

    const fetchAllData = useCallback(async () => {
        if (!dataPpmKapal?.nomorAjuKapal || !dataDisposisi?.noTugas) {
            console.log("data Kapal atau data disposisi kosong")
            return
        }

        try {
            let isOver5Gt = dataPpmKapal.ukuranKapal <= 5 ? 'T' : 'Y'
            let isPembeku = dataPpmKapal.fasilitasPembeku === '1' ? 'Y' : 'T'
            setIsPembeku(isPembeku)

            const results = await Promise.allSettled([
                kapalService.listDokumenWajib(isOver5Gt, isPembeku),
                kapalService.listHasilEvPermohonan(dataPpmKapal.nomorAjuKapal),
                kapalService.getMasterKapalById(dataPpmKapal.idKapal)
            ])

            const [resDokWajib, resHasilEvp, resMasterKapal] = results

            const getData = (res, fallback = []) =>
                res.status === "fulfilled"
                    ? res.value?.data?.data ?? res.value?.data ?? fallback
                    : fallback;

            const hasilEvp = resHasilEvp.value?.data?.data?.[0]

            const resHasilEvpDok = await kapalService.listHasilEvPermohonanDok(dataPpmKapal.nomorAjuKapal, hasilEvp.idEvp)
            setHasilEvpDok(resHasilEvpDok.data.data)
            setValueCatatan(hasilEvp.catatanPeriksa)
            setValuePemeriksa(hasilEvp.nmPeriksa)
            setValueTanggalPeriksa(hasilEvp.tglPeriksa)

            setListDokWajib(getData(resDokWajib))
            setMasterKapal(getData(resMasterKapal))

        } catch (error) {
            console.log(error)
        }
    }, [dataPpmKapal, dataDisposisi, kapalService])

    useEffect(() => {
        let isMounted = true;
        if (!dataPpmKapal) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [dataPpmKapal, fetchAllData]);

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={[styles.table, { marginBottom: 3 }]}>
                    <View style={[styles.tableRow, { borderBottom: 2, borderBottomStyle: 'solid' }]}>
                        <View style={[styles.tableCol, { width: '25%' }]}>
                            <Image style={styles.headingImg} src={imgKkp} />
                        </View>
                        <View style={[styles.tableCol, { width: '70%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'center', color: '#7895be' }]}>KEMENTERIAN KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.text, { fontSize: 14, textAlign: 'center', color: '#7895be' }]}>BADAN PENGENDALIAN DAN PENGAWASAN MUTU</Text>
                            <Text style={[styles.text, { fontSize: 14, textAlign: 'center', color: '#7895be' }]}>HASIL KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>JALAN MEDAN MERDEKA TIMUR NO. 16</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>JAKARTA 10110, KOTAK POS 4130 JKP 10041</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>TELEPON (021) 3519070 (LACAK), FAKSIMILE (021) 3513282</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>LAMAN www.kkp.go.id</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 5 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>FORM PEMERIKSAAN DOKUMEN PERMOHONAN</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={[styles.tableRow, { marginBottom: 10 }]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Kelengkapan dokumen legal aspek terhadap permohonan Sertifikasi Cara Penanganan Ikan yang Baik di Kapal Perikanan sebagai berikut:</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '20%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Nama Kapal</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '74%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataPpmKapal ? dataPpmKapal.namaKapal : ''}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Alamat</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '74%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{masterKapal && masterKapal.alamatPemilik}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Status</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '74%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataPpmKapal ? (dataPpmKapal.statusPermohonan === '1' ? 'Permohonan Baru' : 'Perpanjangan') : ''}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.tableIdt}>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderTopWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableCol, { width: "5%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.textBold, { paddingTop: 9, fontSize: 10 }]}>No.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "42%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.textBold, { paddingTop: 9, fontSize: 10 }]}>Dokumen</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "5%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.textBold, { paddingTop: 9, fontSize: 10 }]}>NR</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "24%", alignItems: "center", borderRightWidth: 1 }]}>
                            <View style={[styles.tableRow]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "center" }]}>
                                    <Text style={[styles.textBold, { fontSize: 10, textAlign: "center" }]}>
                                        Kelengkapan
                                    </Text>
                                </View>
                            </View>
                            <View style={[styles.tableRow]}>
                                <View style={[styles.tableCol, { width: "50%", alignItems: "center", borderTopWidth: 1, borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                    <Text style={[styles.textBold, { fontSize: 10, textAlign: "center" }]}>
                                        Ada
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "50%", alignItems: "center", borderTopWidth: 1, borderBottomWidth: 1 }]}>
                                    <Text style={[styles.textBold, { fontSize: 10, textAlign: "center" }]}>
                                        Tidak
                                    </Text>
                                </View>
                            </View>
                        </View>
                        <View style={[styles.tableCol, { width: "24%", alignItems: "center", borderRightWidth: 1 }]}>
                            <View style={[styles.tableRow]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "center" }]}>
                                    <Text style={[styles.textBold, { fontSize: 10, textAlign: "center" }]}>
                                        Kesesuaian
                                    </Text>
                                </View>
                            </View>
                            <View style={[styles.tableRow]}>
                                <View style={[styles.tableCol, { width: "50%", alignItems: "center", borderTopWidth: 1, borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                    <Text style={[styles.textBold, { fontSize: 10, textAlign: "center" }]}>
                                        Sesuai
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "50%", alignItems: "center", borderTopWidth: 1, borderBottomWidth: 1 }]}>
                                    <Text style={[styles.textBold, { fontSize: 10, textAlign: "center" }]}>
                                        Tidak
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableCol, { width: "5%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.textBold, { fontSize: 10 }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: "42%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.textBold, { fontSize: 10 }]}>{dataPpmKapal ? (dataPpmKapal.statusPermohonan === '1' ? 'Permohonan Baru' : 'Perpanjangan') : ''}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "5%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={styles.text}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: "12%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={styles.text}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: "12%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={styles.text}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: "12%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={styles.text}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: "12%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={styles.text}></Text>
                        </View>
                    </View>
                    {
                        listDokWajib && listDokWajib.map((dokwajib, idx) => {
                            const current = hasilEvpDok.find((h) => h.idJenisDok === dokwajib.idJenisDok)
                            return (
                                <View key={idx} style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1 }]}>
                                    <View style={[styles.tableCol, { width: "5%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                        <Text style={styles.text}>{idx + 1}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "42%", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                        <Text style={styles.text}><JenisDokumenKapal id={dokwajib.idJenisDok} /></Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "5%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                        <Text style={styles.text}></Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "12%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                        <Text style={styles.text}>{current?.isLengkap === "1" && <Image src={imgCheck} style={styles.checkicon} />}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "12%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                        <Text style={styles.text}>{current?.isLengkap === "0" && <Image src={imgCheck} style={styles.checkicon} />}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "12%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                        <Text style={styles.text}>{current?.isSesuai === "1" && <Image src={imgCheck} style={styles.checkicon} />}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "12%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                        <Text style={styles.text}>{current?.isSesuai === "0" && <Image src={imgCheck} style={styles.checkicon} />}</Text>
                                    </View>
                                </View>
                            )
                        })
                    }
                </View>
                {
                    isPembeku && isPembeku === 'Y' &&
                    <View style={styles.table}>
                        <View style={[styles.tableRow, { marginBottom: 10 }]}>
                            <View style={[styles.tableCol, { width: '100%' }]}>
                                <Text style={[styles.text, { textAlign: 'left' }]}>* Khusus untuk kapal pembeku</Text>
                            </View>
                        </View>
                    </View>
                }
                <View style={[styles.table, { marginBottom: 10 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.textBold, { textAlign: 'left' }]}>Catatan :</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{valueCatatan}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, width: '30%' }]}>
                            <Text style={[styles.text, { textAlign: 'left' }]}>Tanggal Pemeriksaan</Text>
                        </View>
                        <View style={[styles.tableRow, { width: '30%', borderRightWidth: 1, borderTopWidth: 1 }]}>
                            <Text style={[styles.text, { textAlign: 'left' }]}>{valueTanggalPeriksa ? formatDateStringLocalDateINA(valueTanggalPeriksa) : ''}</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableRow, { paddingBottom: 15, borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderBottomWidth: 1, width: '30%' }]}>
                            <Text style={[styles.text, { textAlign: 'left' }]}>Pemeriksa :</Text>
                        </View>
                        <View style={[styles.tableRow, { paddingBottom: 15, width: '30%', borderRightWidth: 1, borderTopWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { textAlign: 'left' }]}>{valuePemeriksa}</Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    )
}

export default CetakFormPeriksaDokPPM